import { render, staticRenderFns } from "./BuyLabelPopup.vue?vue&type=template&id=3a2aa1b6&scoped=true"
import script from "./BuyLabelPopup.vue?vue&type=script&lang=js"
export * from "./BuyLabelPopup.vue?vue&type=script&lang=js"
import style0 from "./BuyLabelPopup.vue?vue&type=style&index=0&id=3a2aa1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2aa1b6",
  null
  
)

export default component.exports